import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import { Text, type TextProps } from '../text/text';
import styles from './text-label.module.scss';

export type TextLabelProps = PropsWithChildren<{
  className?: string;
  disabled?: boolean;
}> &
  Pick<TextProps, 'bold'>;

export const TextLabel: FC<TextLabelProps> = ({ bold, children, className, disabled }) => (
  <Text bold={bold} className={classNames(styles.text, disabled && styles.disabled, className)} size="l">
    {children}
  </Text>
);
